import {AxiosError} from 'axios';
import {
  GET_CANDIDATE_UNIQUE_LINK_COUNT_URL,
  GET_CANDIDATE_WITHDRAWAL_UNIQUE_LINK_COUNT_URL,
} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {PaginatedData} from '../../models/List';
import {GenericErrorResponse} from '../typings';
import {useCustomMutation} from '../utils/useCustomMutation';

export interface CandidateUniqueLinkCountResponse {
  uinFinPassport: string;
  candidateName: string;
  email: string;
  school: string;
  uuid: string;
  uniqueLinkCount: number;
}

export interface CandidateSearchNoPageRequest {
  q: string;
}

interface PostCandidateLinkSearchArgs {
  page: number;
  size: number;
  body: CandidateSearchNoPageRequest;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PaginatedData<CandidateUniqueLinkCountResponse>) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCandidateLinkSearchNoPagination = ({
                                                         onSuccess,
                                                         onError,
                                                       }: {
  onSuccess?: (data: PaginatedData<CandidateUniqueLinkCountResponse>) => void;
  onError?: (e: any) => void;
} = {}) => {
  const postCandidateSearch = async ({page, size, body}: PostCandidateLinkSearchArgs) => {
    const res = await axiosClient.post<PaginatedData<CandidateUniqueLinkCountResponse>>(
        GET_CANDIDATE_UNIQUE_LINK_COUNT_URL(page, size),
        body
    );
    return res.data;
  };

  return useCustomMutation(postCandidateSearch, {onSuccess, onError});
};

export const usePostCandidateWithdrawalLinkSearchNoPagination = ({
                                                                   onSuccess,
                                                                   onError,
                                                                 }: {
  onSuccess?: (data: PaginatedData<CandidateUniqueLinkCountResponse>) => void;
  onError?: (e: any) => void;
} = {}) => {
  const postCandidateSearch = async ({page, size, body}: PostCandidateLinkSearchArgs) => {
    const res = await axiosClient.post<PaginatedData<CandidateUniqueLinkCountResponse>>(
        GET_CANDIDATE_WITHDRAWAL_UNIQUE_LINK_COUNT_URL(page, size),
        body
    );
    return res.data;
  };

  return useCustomMutation(postCandidateSearch, {onSuccess, onError});
};
